import { render } from "./StafetDeltagPaaHoldStepYourInformation.vue?vue&type=template&id=73f090e6"
import script from "./StafetDeltagPaaHoldStepYourInformation.vue?vue&type=script&lang=js"
export * from "./StafetDeltagPaaHoldStepYourInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__